import React from "react";
import { Link } from "react-router-dom";

const FrontendEngineer = () => {
  return (
    <div className="Job-listing">
      <p>
        At Dark, we're making it radically easier to build backends. As
        a frontend engineer, we think you’ll care because a big piece is making
        it possible for you to easily add a backend and infrastructure to
        an SPA or mobile app.
      </p>

      <p>
        We're doing so by creating a holistic development experience: language,
        editor, and infrastructure.
      </p>

      <h2>As a frontend engineer on our team: </h2>

      <ul>
        <li>
          You'll work side by side with the rest of the team. You'll work most
          closely with Sydney, our first frontend engineer, and Alice our
          designer (Alice was an engineer for seven years before this, too!)
        </li>
        <li>
          You get to be an expert for the Dark editor. It’s not just text: it’s
          a combination of text, UI elements, and tooling.
        </li>
        <li>
          You won’t be stuck only working on the frontend. Both the Dark frontend and backend are
          written in OCaml! You’ll be able to branch out into the other
          difficult and challenging technical problems facing Dark, like our
          language and infrastructure compiler.
        </li>
        <li>
          We use Dark to build projects and internal tools, so there will be
          chances to put together front ends in React, Vue, Flutter, or anything
          else you’ve been wanting to try.
        </li>
      </ul>

      <p>
        Want to know more about what it’s like to work at Dark (regardless of
        role?) We've shared our <Link to="/about#values">values</Link> and
        <Link to="/about#team"> our team</Link>.
      </p>

      <h2>We hope you: </h2>
      <ul>
        <li>Have built a wide array of products.</li>
        <li>
          Have opinions about frontend architecture. We're excited to hear about
          tradeoffs between various solutions and how to optimize performance.
        </li>
        <li>
          Are comfortable iterating rapidly. We're a super-early stage startup –
          we need to iterate quickly to validate concepts. You need to be
          comfortable building quickly and responding to review feedback.
        </li>
      </ul>

      <p>
        To apply, email <a href="mailto:careers@darklang.com">careers@darklang.com</a>{" "}
        with whatever you’d like us to know off the bat: it could be your
        resume, LinkedIn, some things you’ve worked on before, or an explanation of
        why Dark caught your eye. You can also see our <Link to="/careers/interviewing">
        full interview process</Link>.
      </p>
    </div>
  );
};

export default FrontendEngineer;
